import $ from "jquery";

/**
 * ProductGallery class.
 * 
 * @since 0.4.0
 * @class ProductGallery
 */
class ProductGallery {
    /**
     * Creates an instance of ProductGallery.
     * 
     * @since 0.4.0
     * @memberof ProductGallery
     */
    constructor() {
        this.carousel = document.querySelector( '#ts-product-images-carousel' );
        this.thumbnailsCarousel = document.querySelector( '#ts-product-thumbnails-carousel' );
        this.galleryLinks = document.querySelectorAll( '.js-product-gallery-link' );
        this.galleryZooms = document.querySelectorAll( '.js-product-gallery-zoom' );
        this.galleryPhotoswipe = document.querySelectorAll( '.js-product-gallery-photoswipe' );
        this.events = this.events.bind( this );
        this.initThumbnailsCarousel = this.initThumbnailsCarousel.bind( this );
        this.initCarousel = this.initCarousel.bind( this );
        this.goToSlide = this.goToSlide.bind( this );
        this.initZoom = this.initZoom.bind( this );
        this.initPhotoswipe = this.initPhotoswipe.bind( this );

        this.events();
        this.initThumbnailsCarousel();
        this.initCarousel();
        this.initZoom();
    }

    /**
     * Listens for events.
     *
     * @since 0.4.0
     * @since 1.2.3 Added event listener for the found_variation event.
     * @listens event:click
     * @listens event:found_variation
     * @memberof ProductGallery
     */
    events() {
        !!this.galleryLinks.length && this.galleryLinks.forEach( elem => {
            elem.addEventListener( 'click', this.goToSlide );
        } );

        !!this.galleryLinks.length && $( document ).on( 'found_variation', () => {
            const variationID = document.querySelector( 'input[name="variation_id"]' ).value;
            const linkElement = document.querySelector( `a[data-variation-id="${variationID}"]` );
            linkElement && linkElement.click();
        } );

        "1" === window.app.photoswipe_enabled && !!this.galleryPhotoswipe.length && this.galleryPhotoswipe.forEach( elem => {
            elem.addEventListener( 'click', this.initPhotoswipe );
        } );
    }

    /**
     * Inits the thumbnails carousel.
     *
     * @since 0.7.0
     * @returns
     * @memberof ProductGallery
     */
    initThumbnailsCarousel() {
        if ( !this.thumbnailsCarousel ) {
            return;
        }

        const settings = {
            adaptiveHeight: true,
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 3,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        dots: false,
                        vertical: true,
                        verticalSwiping: true,
                        arrows: true,
                        prevArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-up.png" class="ts-slider__arrow ts-slider__arrow--up">`,
                        nextArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-down.png" class="ts-slider__arrow ts-slider__arrow--down">`,
                    }
                }
            ],
        };
        $( this.thumbnailsCarousel ).slick( settings );
    }

    /**
     * Inits the carousel.
     *
     * @since 0.4.0
     * @returns
     * @memberof ProductGallery
     */
    initCarousel() {
        if ( !this.carousel ) {
            return;
        }

        const settings = {
            adaptiveHeight: true,
            arrows: false,
            dots: false,
            infinite: false,
            speed: 600,
            swipe: false,
        };
        $( this.carousel ).slick( settings );
    }

    /**
     * Goes to a slide by index.
     *
     * @since 0.4.0
     * @param object e
     * @returns
     * @memberof ProductGallery
     */
    goToSlide( e ) {
        e.preventDefault();

        if ( !this.carousel ) {
            return;
        }

        const index = e.target.closest( '.js-product-gallery-link' ).getAttribute( 'data-slick' );
        $( this.carousel ).slick( 'slickGoTo', parseInt( index ) );
    }

    /**
     * Init the images zoom functionality.
     *
     * @since 0.4.0
     * @returns
     * @memberof ProductGallery
     */
    initZoom() {
        if ( "1" !== window.app.zoom_enabled || 0 === this.galleryZooms.length ) {
            return;
        }

        this.galleryZooms.forEach( elem => {
            const url = elem.getAttribute( 'href' );
            if (typeof $( elem ).zoom === 'function') {
                $( elem ).zoom( { url, magnify: 1.2, touch: false } );
            }
        } );
    }

    /**
     * Inist photoswipe lightbox.
     *
     * @since 0.4.0
     * @param object e
     * @memberof ProductGallery
     */
    initPhotoswipe( e ) {
        e.preventDefault();

        const clickedElement = e.target.closest( '.js-product-gallery-photoswipe' );
        const options = {
            index: parseInt( clickedElement.getAttribute( 'data-index' ) ),
            zoomEl: false,
            shareEl: false,
        };
        let items = [];

        this.galleryPhotoswipe.forEach( elem => {
            const element = elem.closest( '.js-product-gallery-photoswipe' );
            items.push( {
                src: element.getAttribute( 'href' ),
                w: parseInt( element.getAttribute( 'data-image-width' ) ),
                h: parseInt( element.getAttribute( 'data-image-height' ) ),
                msrc: element.getAttribute( 'data-image-small' ),
            } );
        } );

        const gallery = new PhotoSwipe( document.querySelector( '.pswp' ), PhotoSwipeUI_Default, items, options );
        gallery.init();
    }
}

export default ProductGallery;
